<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{titleText}}</div>
    <div slot="body">
      <a-alert v-if="params.type !== 'confirm'" class="mb-2" type="warning" :message="$t('bill.batch_ignore_tips')" banner />
      <dialog-selected-tips :name="$t('bill.suggest')" :count="params.data.length" :action="params.type === 'confirm' ? $t('meter.confirm_suggest') : $t('bill.text_269')" :unit="$t('bill.text_270')" />
      <dialog-table class="mb-2" :data="params.data" :columns="params.columns.slice(0, 3)" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BatchIgnoreDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    titleText () {
      let ret = this.$t('bill.text_268')
      if (this.params.type === 'confirm') ret = this.$t('meter.confirm_suggest')
      if (this.params.type === 'cancel-ignore') ret = this.$t('bill.text_271')
      return ret
    },
    action () {
      return this.params.type || 'ignore'
    },
  },
  methods: {
    doAction () {
      return this.params.onManager('performAction', {
        id: this.params.data[0].id,
        managerArgs: {
          action: this.action,
          data: {
            scope: this.$store.getters.scope,
            // batch_ignore: true,
          },
        },
      }).then(ret => {
        this.$message.success(this.$t('bill.text_59'))
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        await this.doAction()
        this.loading = false
        this.cancelDialog()
        this.params.success && this.params.success()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>
